import reducer from './reducers';

import * as editPasswordSelectors from './selectors';
import * as editPasswordOperations from './operations';
import * as editPasswordTypes from './types';

export { editPasswordSelectors, editPasswordOperations, editPasswordTypes };

export default reducer;
